/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Internal_Only_LabelInputs */



/**
* | output |
* | --- |
* | "Only use internal sources" |
*
* @param {Rag_Internal_Only_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_internal_only_label = /** @type {((inputs?: Rag_Internal_Only_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Internal_Only_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausschließlich interne Quellen verwenden")
	return /** @type {LocalizedString} */ ("Only use internal sources")
});